// Who asked a member question, for which city, when, and how long it has
// waited (2026-11-03; backend admin.vaultQuestionController withAskerFields).
// The list draws AskedByInline next to the "member submitted" tag and
// AskedByTimes under it; the question's View page draws AskedByBlock.
import React from "react";
import { Link } from "react-router-dom";
import { formatEt } from "../User/introPauseUtils";
import { askerLabel, askerPagePath, askedAtLine, waitingLine, internalNoteLine } from "./memberQuestionUtils";

// The name opens the member's Admin page; a deleted account's is plain text.
const AskerLink = ({ item }) => {
  const path = askerPagePath(item);
  const name = askerLabel(item);
  return path ? (
    <Link to={path} className="text-decoration-underline" style={{ whiteSpace: "nowrap" }} title="Open this member">
      {name}
    </Link>
  ) : (
    <span style={{ whiteSpace: "nowrap" }}>{name}</span>
  );
};

const Waiting = ({ item }) => {
  const waiting = waitingLine(item);
  if (!waiting) return null;
  return <div className={`text-sm fw-medium ${waiting.late ? "text-danger-600" : "text-secondary-light"}`}>{waiting.text}</div>;
};

/** "· Nicole (..1b143b) · Ottawa" */
export const AskedByInline = ({ item }) => {
  if (!item || !item.askedBy) return null;
  return (
    <span className="text-sm text-secondary-light">
      {" · "}
      <AskerLink item={item} />
      {item.askedPocketName ? ` · ${item.askedPocketName}` : ""}
    </span>
  );
};

/** "Asked Oct 18, 11:11 PM ET", then "Waiting 16 days" while it waits. */
export const AskedByTimes = ({ item }) => {
  if (!item || !item.askedBy) return null;
  const asked = askedAtLine(item);
  return (
    <>
      {asked ? (
        <div className="text-sm text-secondary-light" style={{ marginTop: 4 }}>
          {asked}
        </div>
      ) : null}
      <Waiting item={item} />
    </>
  );
};

/** The View page: "Asked by: Nicole (..1b143b), Ottawa, Oct 18, 11:11 PM ET", the wait, the internal note. */
export const AskedByBlock = ({ item }) => {
  if (!item || !item.askedBy) return null;
  const when = formatEt(item.askedAt);
  const note = internalNoteLine(item);
  return (
    <div className="col-md-12 mb-3">
      <label className="form-label fw-bold">Asked by:</label>
      <div>
        <AskerLink item={item} />
        {item.askedPocketName ? `, ${item.askedPocketName}` : ""}
        {when ? `, ${when}` : ""}
      </div>
      <Waiting item={item} />
      {/* Never the untrue "Publish to run it" note (memberQuestionUtils). */}
      {note ? (
        <div className="text-sm text-secondary-light" style={{ marginTop: 4 }}>
          Internal note: {note}
        </div>
      ) : null}
    </div>
  );
};
